import { useCallback } from 'react'
import { useSelector } from 'react-redux'

import { format, utcToZonedTime } from 'date-fns-tz'

import { TREATMENT_MODE } from '@lyrahealth-inc/shared-app-logic/src/features/common/constants/appointmentModalityConstants'
import { MEETING_FORMATS } from '@lyrahealth-inc/shared-app-logic/src/models/session/Session'

import { getAuthUserId } from '../../../../../data/auth/authSelectors'
import { useCreateAppointmentMutation } from '../appointmentsApi'

const DEFAULT_LEGACY_APPOINTMENT_DURATION_MIN = 50

export const useBookLegacyAppointment = () => {
  const [createAppointment] = useCreateAppointmentMutation()
  const userId = useSelector(getAuthUserId)

  return useCallback(
    async (event: {
      client: string
      localStartTime: string
      duration?: number
      meetingFormat: string
      address?: string
    }) => {
      const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone ?? 'America/Los_Angeles'

      const date = utcToZonedTime(event.localStartTime, timeZone)
      const startTime = format(date, 'HH:mm:ss', { timeZone })
      const startDate = format(date, 'yyyy-MM-dd', { timeZone })

      return await createAppointment({
        providerId: userId,
        data: {
          startDate,
          startTime,
          timeZone,
          appointmentStatus: 'newAppt',
          appointmentDuration: event.duration ?? DEFAULT_LEGACY_APPOINTMENT_DURATION_MIN,
          meetingFormat: event.meetingFormat as MEETING_FORMATS,
          lyraProviderId: userId,
          userId: event.client,
          title: 'New Appointment',
          details: '',
          supportedVisitTypes: TREATMENT_MODE.BOTH_VIDEO_INPERSON,
          ...(event.address && { address: event.address }),
        },
      }).unwrap()
    },
    [userId, createAppointment],
  )
}
